import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    // accategoriesChannel = new Subject();
    createChannel = new Subject();
    empChannel = new Subject();
    periodChannel = new Subject();
    performanceChannel = new Subject();
    stankomChannel = new Subject();
    detailempChannel = new Subject();
    levelChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    // fetchCategories = async (query) => {
    //     this.accategoriesChannel.next({status: apiResponse.LOADING})
    //     await this.repository.fetchCategories(query).then((result) => {
    //         this.accategoriesChannel.next({status: apiResponse.COMPLETED, data: result})
    //     }).catch((error) => {
    //         this.accategoriesChannel.next({status: apiResponse.ERROR, data: error})
    //     })
    // }
    fetchEmployee = async (query) => {
        this.empChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchEmployee(query).then((result) => {
            this.empChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.empChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchPeriod = async (query) => {
        this.periodChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPeriod(query).then((result) => {
            this.periodChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.periodChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchPerformance = async (query) => {
        this.performanceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPerformance(query).then((result) => {
            this.performanceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.performanceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchStankom = async (query) => {
        this.stankomChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchStankom(query).then((result) => {
            this.stankomChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.stankomChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailEmployee = async (query) => {
        this.detailempChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailEmployee(query).then((result) => {
            this.detailempChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailempChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchStankom = async (query) => {
        this.stankomChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchStankom(query).then((result) => {
            this.stankomChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.stankomChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetcLevelCompetence = async (query) => {
        this.levelChannel.next({status: apiResponse.LOADING})
        await this.repository.fetcLevelCompetence(query).then((result) => {
            this.levelChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.levelChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}

export default CreateBloc